<div class="info-page">
  <div class="info-card">
    <h2>Info</h2>

    <div class="form-group">
      <label for="name">Navn</label>
      <input id="name"
             type="text"
             class="text-field"
             [ngModel]="equipment.name"
             disabled
             name="name" />
    </div>

    <div class="section-title">Leverandør</div>

    <div class="form-group">
      <label for="supplierName">Navn</label>
      <input id="supplierName"
             type="text"
             class="text-field"
             [ngModel]="equipment.supplierName"
             disabled
             name="supplierName" />
    </div>

    <div class="section-title">Model</div>

    <div class="form-group">
      <label for="model">Navn</label>
      <input id="model"
             type="text"
             class="text-field"
             [ngModel]="equipment.model"
             disabled
             name="model" />
    </div>

    <div class="form-group">
      <label for="series">Serie nr</label>
      <input id="series"
             type="text"
             class="text-field"
             [ngModel]="equipment.series"
             disabled
             name="series" />
    </div>

    <div class="form-group">
      <label for="purchaseDate">Indkøbt</label>
      <input id="purchaseDate"
             type="text"
             class="text-field"
             [ngModel]="equipment.purchaseDateText"
             disabled
             name="purchaseDate" />
    </div>

    <div class="form-group">
      <label for="departmentName">Afdeling</label>
      <input id="departmentName"
             type="text"
             class="text-field"
             [ngModel]="equipment.departmentName"
             disabled
             name="departmentName" />
    </div>

    <div class="form-group">
      <label for="placement">Placering</label>
      <input id="placement"
             type="text"
             class="text-field"
             [ngModel]="equipment.placement"
             disabled
             name="placement" />
    </div>

    <div class="form-group">
      <label for="responsibleName">Ansvarlig</label>
      <input id="responsibleName"
             type="text"
             class="text-field"
             [ngModel]="equipment.responsibleName"
             disabled
             name="responsibleName" />
    </div>
  </div>
</div>
